import * as React from 'react';

const SvgZoom = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_118_1176)">
      <g clipPath="url(#clip1_118_1176)">
        <path
          d="M24.062 48.125C37.352 48.125 48.125 37.3511 48.125 24.062C48.125 10.773 37.352 0 24.062 0C10.772 0 0 10.773 0 24.062C0 37.3511 10.773 48.125 24.062 48.125Z"
          fill="#2196F3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1201 30.9394H30.0345V19.2698C30.0345 17.5117 28.6098 16.0869 26.8516 16.0869H10.9373V27.7565C10.9373 29.5146 12.362 30.9394 14.1201 30.9394ZM32.1555 26.6965L38.5212 30.9394V16.0869L32.1564 20.3308L32.1555 26.6965Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_118_1176">
        <rect width={48} height={48} fill="white" />
      </clipPath>
      <clipPath id="clip1_118_1176">
        <rect width={48.125} height={48.125} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgZoom;
